import { OFFSCREEN_X, OFFSCREEN_Y, DEFAULT_COLOR, MOBILE_WIDTH, SPRITE_SCALE, MAX_WIDTH, UNMAPPED} from "./Constants";
import * as PIXI from 'pixi.js';
import * as d3 from "d3";
import * as topojson from "topojson-client";
import {getWidth, getHeight} from "./Utils";

export default function renderMap() {
	this.width = getWidth();
	this.height = getHeight();
	this.max_size = Math.min(this.width, MAX_WIDTH);
	this.max_grid_size = this.width < MOBILE_WIDTH ? this.max_size : this.max_size/2 - this.max_size/8;
	this.map_margin =  this.width > MOBILE_WIDTH ? {top: 100, left: 200} : {top:0, left:0};
	this.tiles = topojson.feature(this.data.topojson, this.data.topojson.objects.tiles_precision8);
	this.dissolved = topojson.feature(this.data.dissolved, this.data.dissolved.objects.dissolved);
	this.projection = d3.geoEquirectangular().fitSize([Math.min(this.max_grid_size, Math.ceil(this.aspectRatio[0] * this.ratio * this.baseScale)), Math.min(this.max_grid_size, Math.ceil(this.aspectRatio[1] * this.ratio * this.baseScale))], this.tiles);
	this.dissolved_projection = d3.geoEquirectangular().fitSize([Math.min(this.max_grid_size, Math.ceil(this.aspectRatio[0] * this.ratio * this.baseScale)), Math.min(this.max_grid_size, Math.ceil(this.aspectRatio[1] * this.ratio * this.baseScale))], this.dissolved);
	this.sprites = [];
	this.sprites1 = [];
	this.sprites2 = [];
	this.spares = [];

	let texture = new PIXI.Texture(PIXI.Texture.WHITE || createWhiteTexture());
	let path = d3.geoPath().projection(this.projection);

	if (this.isWebGL && +PIXI.VERSION[0] > 3) {
		this.container = new PIXI.ParticleContainer(this.tiles.features.length + 200, {/*vertices: true, */tint:true, scale:true, alpha:true});
		this.spares_container = new PIXI.ParticleContainer(200, {tint:true, scale: true, alpha:true});
		this.country = new PIXI.ParticleContainer(this.tiles.features.length + 200, {/*vertices: true, */tint:true, scale:true, alpha:true});
	} else {
		this.container = new PIXI.Container();
		this.spares_container = new PIXI.Container();
		this.country = new PIXI.Container();
	}
	this.spares_container.renderable = false;
	this._container = new PIXI.Container();
	this._container.interactive = false;
	this._container.interactiveChildren = false;
	this.container.interactiveChildren = false;
	this.boundaries = new PIXI.Container();
	this._container.addChild(this.boundaries);
	this.boundaries.interactive = false;
	this.boundaries.renderable = false;
	this._container.addChild(this.container);
	this._container.addChild(this.spares_container);
	this._container.addChild(this.country);
	this.app.stage.addChild(this._container);

	function createWhiteTexture() {
	  const canvas = document.createElement('canvas');
	  canvas.width = 16;
	  canvas.height = 16;
	  const context = canvas.getContext('2d');
	  context.fillStyle = 'white';
	  context.fillRect(0, 0, 16, 16);
	  return PIXI.Texture.fromCanvas(canvas);
	}

	const sprite_factory = (id, d, path, texture, force_iso=undefined)  => {
		let sprite = new PIXI.Sprite(texture);
		let coords = path.centroid(d);
		let bounds = path.bounds(d);
		sprite.anchor.set(0.5);
		sprite.tint = DEFAULT_COLOR;
		sprite.id = id;
		sprite.iso = typeof force_iso === 'undefined' ? d.properties.i : force_iso;
		sprite.mx = typeof force_iso === 'undefined' ? sprite.x = coords[0] + this.map_margin.left : OFFSCREEN_X;
		sprite.my = typeof force_iso === 'undefined' ? sprite.y = coords[1] + this.map_margin.top : OFFSCREEN_Y;
		sprite.width = Math.abs(bounds[1][0] - bounds[0][0]);
		sprite.height = Math.abs(bounds[1][1] - bounds[0][1]);
		sprite.baseScale = sprite.scale.y = sprite.scale.x *= this.no_alias ? 1.2 : SPRITE_SCALE;
		return sprite;
	};

	for (let i = 0; i < this.tiles.features.length; i++ ) {
		if (i < UNMAPPED.length ) {
			this.spares.push(sprite_factory(i + this.tiles.features.length, this.tiles.features[i], path, texture, UNMAPPED[i]));
			this.sprites1.push(sprite_factory(i, this.tiles.features[i], path, texture, UNMAPPED[i]));
		}
			this.sprites.push(sprite_factory(i, this.tiles.features[i], path, texture));
	}

	this.container.addChild(...this.sprites);
	this.container.addChild(...this.spares);
	this.spares_container.addChild(...this.sprites1);
}
